import { render, staticRenderFns } from "./AxNavigation.vue?vue&type=template&id=7dc52796&scoped=true&"
import script from "./AxNavigation.vue?vue&type=script&lang=ts&"
export * from "./AxNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AxNavigation.vue?vue&type=style&index=0&id=7dc52796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc52796",
  null
  
)

export default component.exports